import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dialog", "form", "container", "token"];

  connect() {
    this.dialogTarget.showModal();

    const widgetId = turnstile.render(this.containerTarget, {
      sitekey: this.containerTarget.dataset.sitekey,
      callback: (token) => {
        this.tokenTarget.value = token;
        this.formTarget.requestSubmit();
      },
      "error-callback": () => {
        this.tokenTarget.value = "";
        setTimeout(() => {
          this.formTarget.requestSubmit();
        }, 1000);
      },
    });
  }

  openDialog(e) {
    this.dialogTarget.showModal();
  }

  closeFromBackdropDialog(e) {
    if (e.type == "mousedown" && e.target == this.dialogTarget) {
      this.dialogTarget.close();
    }
  }

  close() {
    this.dialogTarget.close();
  }

  autocloserTargetConnected(element) {
    setTimeout(() => {
      this.close();
    }, 2000);
  }
}
